import { render, staticRenderFns } from "./infoCell.vue?vue&type=template&id=0d515a94&scoped=true"
import script from "./infoCell.vue?vue&type=script&lang=js"
export * from "./infoCell.vue?vue&type=script&lang=js"
import style0 from "./infoCell.vue?vue&type=style&index=0&id=0d515a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d515a94",
  null
  
)

export default component.exports